import { useState, createContext, useContext } from "react";

const BannerContext = createContext(null);

export const BannerProvider = ({ children }) => {
  const [showBanner, setShowBanner] = useState(false);

  return (
    <BannerContext.Provider value={{ showBanner, setShowBanner }}>
      {children}
    </BannerContext.Provider>
  );
};

export const useBanner = () => useContext(BannerContext);